// extracted by mini-css-extract-plugin
export default {"title":"card-title_title__I8yhx","heading":"card-title_heading__KCo98","actions":"card-title_actions__c-pUY","bordered":"card-title_bordered__TtZ4O"};